import { Switch } from '@react-spectrum/s2'
import { trackAnalyticsEvent } from '@client/analytics'

type SourcesToggleProps = {
  isSelected: boolean
  onChange: (isSelected: boolean) => void
  size?: 'S' | 'M' | 'L' | 'XL'
  analyticsLocation?: 'desktop_header' | 'mobile_header' | 'unknown'
}

export function SourcesToggle({
  isSelected,
  onChange,
  size,
  analyticsLocation = 'unknown',
}: SourcesToggleProps) {
  const handleChange = (nextSelected: boolean) => {
    trackAnalyticsEvent('sources_toggle_changed', {
      location: analyticsLocation,
      selected: nextSelected,
    })
    onChange(nextSelected)
  }

  return (
    <span className="relative inline-flex">
      <Switch isSelected={isSelected} onChange={handleChange} size={size}>
        Sources
      </Switch>
    </span>
  )
}
